import merge from "lodash/merge";
import { responsiveFontSizes } from "@mui/material/styles";
import { THEMES } from "../constants";
import { lightShadows, darkShadows } from "./shadows";
import { ptBR } from "@mui/material/locale";
import { createTheme } from "@mui/material";
const plataformIsBc = process.env.REACT_APP_PLATAFORM === "BC";
export const getBackgroundPattern = (theme) => ({
  backgroundColor: theme.palette.background.default,
  backgroundImage: theme.palette.background.pattern.image,
  backgroundRepeat: theme.palette.background.pattern.repeat,
  backgroundSize: theme.palette.background.pattern.size,
  backgroundBlendMode: theme.palette.background.pattern.blend,
  backgroundAttachment: theme.palette.background.pattern.attachment,
});

const baseOptions = {
  direction: "ltr",
};

const themesOptions = {
  [THEMES.LIGHT]: {
    components: {
      MuiAvatar: {
        styleOverrides: {
          root: {
            fontSize: 14,
            fontWeight: 600,
            letterSpacing: 0,
            backgroundColor: "#E5E7EB",
            color: "#000",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: "100px",
            textTransform: "none",
            fontWeight: 600,
            letterSpacing: 0,
          },
          sizeSmall: {
            padding: "8px 16px",
          },
          sizeMedium: {
            padding: "10px 24px",
          },
          sizeLarge: {
            padding: "12px 32px",
          },
          textSizeSmall: {
            padding: "8px 12px",
          },
          textSizeMedium: {
            padding: "10px 16px",
          },
          textSizeLarge: {
            padding: "12px 16px",
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 24,
            "&.MuiPaper-elevation1": {
              boxShadow:
                "0px 1px 2px 0px rgba(9, 30, 66, 0.04), 0px 4px 12px 0px rgba(9, 30, 66, 0.02), 0px 0px 0px 1px rgba(9, 30, 66, 0.03)",
            },
          },
        },
      },
      MuiCardContent: {
        styleOverrides: {
          root: {
            padding: "32px 24px",
            "&:last-child": {
              paddingBottom: "32px",
            },
          },
        },
      },
      MuiCardHeader: {
        defaultProps: {
          titleTypographyProps: {
            variant: "h6",
          },
          subheaderTypographyProps: {
            variant: "body2",
          },
        },
        styleOverrides: {
          root: {
            padding: "32px 24px 16px",
          },
        },
      },
      MuiCheckbox: {
        defaultProps: {
          checkedIcon: {
            type: "svg",
            key: null,
            ref: null,
            props: {
              fill: "none",
              height: "24",
              viewBox: "0 0 24 24",
              width: "24",
              xmlns: "http://www.w3.org/2000/svg",
              children: {
                type: "path",
                key: null,
                ref: null,
                props: {
                  clipRule: "evenodd",
                  d: "M9 3.5C5.68629 3.5 3 6.18629 3 9.5V15.5C3 18.8137 5.68629 21.5 9 21.5H15C18.3137 21.5 21 18.8137 21 15.5V9.5C21 6.18629 18.3137 3.5 15 3.5H9ZM16.7179 10.1961C17.1024 9.79966 17.0926 9.16657 16.6961 8.7821C16.2997 8.39763 15.6666 8.40737 15.2821 8.80385L10.6667 13.5635L8.7179 11.5539C8.33343 11.1574 7.70034 11.1476 7.30385 11.5321C6.90737 11.9166 6.89763 12.5497 7.2821 12.9461L9.94877 15.6961C10.1371 15.8904 10.3961 16 10.6667 16C10.9372 16 11.1962 15.8904 11.3846 15.6961L16.7179 10.1961Z",
                  fill: "currentColor",
                  fillRule: "evenodd",
                },
                _owner: null,
              },
            },
            _owner: null,
          },
          color: "primary",
          icon: {
            type: "svg",
            key: null,
            ref: null,
            props: {
              fill: "none",
              height: "24",
              viewBox: "0 0 24 24",
              width: "24",
              xmlns: "http://www.w3.org/2000/svg",
              children: {
                type: "rect",
                key: null,
                ref: null,
                props: {
                  height: "16",
                  rx: "5",
                  stroke: "currentColor",
                  strokeWidth: "2",
                  width: "16",
                  x: "4",
                  y: "4.5",
                },
                _owner: null,
              },
            },
            _owner: null,
          },
          indeterminateIcon: {
            type: "svg",
            key: null,
            ref: null,
            props: {
              fill: "none",
              height: "24",
              viewBox: "0 0 24 24",
              width: "24",
              xmlns: "http://www.w3.org/2000/svg",
              children: {
                type: "path",
                key: null,
                ref: null,
                props: {
                  clipRule: "evenodd",
                  d: "M9 5.5H15C17.2091 5.5 19 7.29086 19 9.5V15.5C19 17.7091 17.2091 19.5 15 19.5H9C6.79086 19.5 5 17.7091 5 15.5V9.5C5 7.29086 6.79086 5.5 9 5.5ZM3 9.5C3 6.18629 5.68629 3.5 9 3.5H15C18.3137 3.5 21 6.18629 21 9.5V15.5C21 18.8137 18.3137 21.5 15 21.5H9C5.68629 21.5 3 18.8137 3 15.5V9.5ZM8 11.5C7.44772 11.5 7 11.9477 7 12.5C7 13.0523 7.44772 13.5 8 13.5H16C16.5523 13.5 17 13.0523 17 12.5C17 11.9477 16.5523 11.5 16 11.5H8Z",
                  fill: "currentColor",
                  fillRule: "evenodd",
                },
                _owner: null,
              },
            },
            _owner: null,
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            fontWeight: 500,
            borderColor: "#E5E7EB",
          },
          /* "icon": {
            "color": "#6C737F"
          } */
        },
      },
      MuiCssBaseline: {
        styleOverrides: {
          "*": {
            boxSizing: "border-box",
          },
          html: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            display: "flex",
            flexDirection: "column",
            minHeight: "100%",
            width: "100%",
          },
          body: {
            display: "flex",
            flex: "1 1 auto",
            flexDirection: "column",
            minHeight: "100%",
            width: "100%",
          },
          "#root, #__next": {
            display: "flex",
            flex: "1 1 auto",
            flexDirection: "column",
            height: "100%",
            width: "100%",
          },
          "#nprogress": {
            pointerEvents: "none",
          },
          "#nprogress .bar": {
            height: 3,
            left: 0,
            position: "fixed",
            top: 0,
            width: "100%",
            zIndex: 2000,
            backgroundColor: plataformIsBc ? "#ff0c72" : "#3695d5",
          },
          ".slick-dots li button": {
            "&:before": {
              fontSize: 10,
              color: plataformIsBc ? "#ff0c72" : "#3695d5",
            },
          },
          ".slick-dots li.slick-active button": {
            "&:before": {
              color: plataformIsBc ? "#ff0c72" : "#3695d5",
            },
          },
        },
      },
      MuiIconButton: {
        styleOverrides: {
          sizeSmall: {
            padding: 4,
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          input: {
            "&::placeholder": {
              opacity: 1,
              color: "#6C737F",
            },
          },
        },
      },
      MuiInput: {
        styleOverrides: {
          input: {
            fontSize: 14,
            fontWeight: 500,
            lineHeight: "24px",
          },
        },
      },
      MuiFilledInput: {
        styleOverrides: {
          root: {
            backgroundColor: "transparent",
            borderRadius: 8,
            borderStyle: "solid",
            borderWidth: 1,
            overflow: "hidden",
            transition:
              "border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
            "&:before": {
              display: "none",
            },
            "&:after": {
              display: "none",
            },
            borderColor: "#E5E7EB",
            "&:hover": {
              backgroundColor: "rgba(17, 25, 39, 0.04)",
            },
            "&.Mui-disabled": {
              backgroundColor: "transparent",
            },
            "&.Mui-focused": {
              backgroundColor: "transparent",
              borderColor: plataformIsBc ? "#ff0c72" : "#3695d5",
              boxShadow: plataformIsBc ? "#ff0c72 0 0 0 2px" : "#3695d5 0 0 0 2px",
            },
            "&.Mui-error": {
              borderColor: "#F04438",
              boxShadow: "#F04438 0 0 0 2px",
            },
          },
          input: {
            fontSize: 14,
            fontWeight: 500,
            lineHeight: "24px",
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          input: {
            fontSize: 14,
            fontWeight: 500,
            lineHeight: "24px",
          },
          notchedOutline: {
            transition:
              "border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
            borderColor: "#b9b9b9",
          },
          root: {
            "&:hover": {
              backgroundColor: "rgba(17, 25, 39, 0.04)",
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#b9b9b9",
              },
            },
            "&.Mui-focused": {
              backgroundColor: "transparent",
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: plataformIsBc ? "#ff0c72" : "#3695d5",
                borderWidth: "3px",
              },
            },
            "&.Mui-error": {
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#F04438",
                borderWidth: "3px",
              },
            },
          },
        },
      },
      MuiFormLabel: {
        styleOverrides: {
          root: {
            fontSize: 14,
            fontWeight: 500,
            "&.MuiInputLabel-filled": {
              transform: "translate(12px, 18px) scale(1)",
            },
            "&.MuiInputLabel-shrink": {
              "&.MuiInputLabel-standard": {
                transform: "translate(0, -1.5px) scale(0.85)",
              },
              "&.MuiInputLabel-filled": {
                transform: "translate(12px, 6px) scale(0.85)",
              },
              "&.MuiInputLabel-outlined": {
                transform: "translate(14px, -9px) scale(0.85)",
              },
            },
          },
        },
      },
      MuiLinearProgress: {
        styleOverrides: {
          root: {
            borderRadius: 3,
            overflow: "hidden",
          },
        },
      },
      MuiLink: {
        defaultProps: {
          underline: "hover",
        },
      },
      MuiListItemIcon: {
        styleOverrides: {
          root: {
            marginRight: "16px",
            minWidth: "unset",
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: "none",
            borderRadius: 24,
          },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: {
            borderRadius: 28,
          },
        },
      },
      MuiPopover: {
        defaultProps: {
          elevation: 16,
        },
      },
      MuiRadio: {
        defaultProps: {
          color: "primary",
        },
      },
      MuiSwitch: {
        defaultProps: {
          color: "primary",
        },
        styleOverrides: {
          switchBase: {
            color: "#6C737F",
          },
          track: {
            backgroundColor: "#9DA4AE",
            opacity: 1,
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            fontSize: 14,
            fontWeight: 500,
            lineHeight: 1.71,
            minWidth: "auto",
            paddingLeft: 0,
            paddingRight: 0,
            textTransform: "none",
            "& + &": {
              marginLeft: 24,
            },
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            padding: "15px 16px",
            borderBottomColor: "#d3d8e0",
          },
        },
      },
      MuiTableHead: {
        styleOverrides: {
          root: {
            borderBottom: "none",
            "& .MuiTableCell-root": {
              borderBottom: "none",
              fontSize: 12,
              fontWeight: 600,
              lineHeight: 1,
              letterSpacing: 0.5,
              textTransform: "uppercase",
              backgroundColor: "#F8F9FA",
              color: "#2F3746",
            },
            "& .MuiTableCell-paddingCheckbox": {
              paddingTop: 4,
              paddingBottom: 4,
            },
          },
        },
      },
      MuiTextField: {
        defaultProps: {
          variant: "filled",
        },
      },
      MuiBackdrop: {
        styleOverrides: {
          root: {
            "&:not(.MuiBackdrop-invisible)": {
              backgroundColor: "rgba(17, 25, 39, 0.75)",
              backdropFilter: "blur(6px)",
            },
          },
        },
      },
      MuiTimelineConnector: {
        styleOverrides: {
          root: {
            backgroundColor: "#d3d8e0",
          },
        },
      },
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            backdropFilter: "blur(6px)",
            background: "rgba(17, 25, 39, 0.8)",
          },
        },
      },
    },
    palette: {
      mode: "light",
      common: {
        black: "#000",
        white: "#fff",
      },
      primary: {
        main: plataformIsBc ? "#ff0c72" : "#3695d5",
        light: plataformIsBc ? "#FF4D98" : "#60A5FA",
        dark: plataformIsBc ? "#CC0A5B" : "#2563EB",
        contrastText: "#FFFFFF",
        lightest: plataformIsBc ? "#FFE6F0" : "#EFF6FF",
        darkest: plataformIsBc ? "#990744" : "#1E3A8A",
        alpha4: plataformIsBc ? "rgba(255, 12, 114, 0.04)" : "rgba(54, 149, 213, 0.04)",
        alpha8: plataformIsBc ? "rgba(255, 12, 114, 0.08)" : "rgba(54, 149, 213, 0.08)",
        alpha12: plataformIsBc ? "rgba(255, 12, 114, 0.12)" : "rgba(54, 149, 213, 0.12)",
        alpha30: plataformIsBc ? "rgba(255, 12, 114, 0.3)" : "rgba(54, 149, 213, 0.3)",
        alpha50: plataformIsBc ? "rgba(255, 12, 114, 0.5)" : "rgba(54, 149, 213, 0.5)",
      },
      secondary: {
        main: "#8B5CF6",
        light: "#A78BFA",
        dark: "#6D28D9",
        contrastText: "#fff",
      },
      error: {
        main: "#EF4444",
        light: "#FEE2E2",
        dark: "#B91C1C",
        contrastText: "#FFFFFF",
        lightest: "#FEF2F2",
        darkest: "#7F1D1D",
        alpha4: "rgba(239, 68, 68, 0.04)",
        alpha8: "rgba(239, 68, 68, 0.08)",
        alpha12: "rgba(239, 68, 68, 0.12)",
        alpha30: "rgba(239, 68, 68, 0.3)",
        alpha50: "rgba(239, 68, 68, 0.5)",
      },
      warning: {
        main: "#F59E0B",
        light: "#FEF3C7",
        dark: "#B45309",
        contrastText: "#FFFFFF",
        lightest: "#FFFBEB",
        darkest: "#78350F",
        alpha4: "rgba(245, 158, 11, 0.04)",
        alpha8: "rgba(245, 158, 11, 0.08)",
        alpha12: "rgba(245, 158, 11, 0.12)",
        alpha30: "rgba(245, 158, 11, 0.3)",
        alpha50: "rgba(245, 158, 11, 0.5)",
      },
      info: {
        main: "#3B82F6",
        light: "#DBEAFE",
        dark: "#1D4ED8",
        contrastText: "#FFFFFF",
        lightest: "#EFF6FF",
        darkest: "#1E3A8A",
        alpha4: "rgba(59, 130, 246, 0.04)",
        alpha8: "rgba(59, 130, 246, 0.08)",
        alpha12: "rgba(59, 130, 246, 0.12)",
        alpha30: "rgba(59, 130, 246, 0.3)",
        alpha50: "rgba(59, 130, 246, 0.5)",
      },
      success: {
        main: "#10B981",
        light: "#D1FAE5",
        dark: "#047857",
        contrastText: "#FFFFFF",
        lightest: "#ECFDF5",
        darkest: "#064E3B",
        alpha4: "rgba(16, 185, 129, 0.04)",
        alpha8: "rgba(16, 185, 129, 0.08)",
        alpha12: "rgba(16, 185, 129, 0.12)",
        alpha30: "rgba(16, 185, 129, 0.3)",
        alpha50: "rgba(16, 185, 129, 0.5)",
      },
      grey: {
        50: "#F9FAFB",
        100: "#F3F4F6",
        200: "#E5E7EB",
        300: "#D1D5DB",
        400: "#9CA3AF",
        500: "#6B7280",
        600: "#4B5563",
        700: "#374151",
        800: "#1F2937",
        900: "#111827",
      },
      contrastThreshold: 3,
      tonalOffset: 0.2,
      text: {
        primary: "#111827",
        secondary: "#6B7280",
        disabled: "rgba(17, 24, 39, 0.38)",
      },
      divider: "#E5E7EB",
      background: {
        paper: "#FFFFFF",
        appBar: "#FFFFFF",
        default: "#F3F4F6",
        pattern: {
          image: "none",
          repeat: "repeat",
          size: "400px",
          blend: "soft-light",
          attachment: "fixed"
        }
      },
      action: {
        active: "#6B7280",
        hover: "rgba(17, 24, 39, 0.04)",
        hoverOpacity: 0.04,
        selected: "rgba(17, 24, 39, 0.08)",
        selectedOpacity: 0.08,
        disabled: "rgba(17, 24, 39, 0.38)",
        disabledBackground: "rgba(17, 24, 39, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(17, 24, 39, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12,
      },
      neutral: {
        50: "#F9FAFB",
        100: "#F3F4F6",
        200: "#E5E7EB",
        300: "#D1D5DB",
        400: "#9CA3AF",
        500: "#6B7280",
        600: "#4B5563",
        700: "#374151",
        800: "#1F2937",
        900: "#111827",
      },
    },
    shadows: lightShadows,
  },

  [THEMES.DARK]: {
    components: {
      MuiAvatar: {
        styleOverrides: {
          root: {
            fontSize: 14,
            fontWeight: 600,
            letterSpacing: 0,
            backgroundColor: "#D2D6DB",
            color: "#000",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: "100px",
            textTransform: "none",
            fontWeight: 600,
            letterSpacing: 0,
          },
          sizeSmall: {
            padding: "8px 16px",
          },
          sizeMedium: {
            padding: "10px 24px",
          },
          sizeLarge: {
            padding: "12px 32px",
          },
          textSizeSmall: {
            padding: "8px 12px",
          },
          textSizeMedium: {
            padding: "10px 16px",
          },
          textSizeLarge: {
            padding: "12px 16px",
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 24,
            "&.MuiPaper-elevation1": {
              boxShadow:
                "0px 4px 6px -1px rgba(0, 0, 0, 0.4), 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(255, 255, 255, 0.05)",
            },
            backgroundImage: "none",
          },
        },
      },
      MuiCardContent: {
        styleOverrides: {
          root: {
            padding: "32px 24px",
            "&:last-child": {
              paddingBottom: "32px",
            },
          },
        },
      },
      MuiCardHeader: {
        defaultProps: {
          titleTypographyProps: {
            variant: "h6",
          },
          subheaderTypographyProps: {
            variant: "body2",
          },
        },
        styleOverrides: {
          root: {
            padding: "32px 24px 16px",
          },
        },
      },
      MuiCheckbox: {
        defaultProps: {
          checkedIcon: {
            type: "svg",
            key: null,
            ref: null,
            props: {
              fill: "none",
              height: "24",
              viewBox: "0 0 24 24",
              width: "24",
              xmlns: "http://www.w3.org/2000/svg",
              children: {
                type: "path",
                key: null,
                ref: null,
                props: {
                  clipRule: "evenodd",
                  d: "M9 3.5C5.68629 3.5 3 6.18629 3 9.5V15.5C3 18.8137 5.68629 21.5 9 21.5H15C18.3137 21.5 21 18.8137 21 15.5V9.5C21 6.18629 18.3137 3.5 15 3.5H9ZM16.7179 10.1961C17.1024 9.79966 17.0926 9.16657 16.6961 8.7821C16.2997 8.39763 15.6666 8.40737 15.2821 8.80385L10.6667 13.5635L8.7179 11.5539C8.33343 11.1574 7.70034 11.1476 7.30385 11.5321C6.90737 11.9166 6.89763 12.5497 7.2821 12.9461L9.94877 15.6961C10.1371 15.8904 10.3961 16 10.6667 16C10.9372 16 11.1962 15.8904 11.3846 15.6961L16.7179 10.1961Z",
                  fill: "currentColor",
                  fillRule: "evenodd",
                },
                _owner: null,
              },
            },
            _owner: null,
          },
          color: "primary",
          icon: {
            type: "svg",
            key: null,
            ref: null,
            props: {
              fill: "none",
              height: "24",
              viewBox: "0 0 24 24",
              width: "24",
              xmlns: "http://www.w3.org/2000/svg",
              children: {
                type: "rect",
                key: null,
                ref: null,
                props: {
                  height: "16",
                  rx: "5",
                  stroke: "currentColor",
                  strokeWidth: "2",
                  width: "16",
                  x: "4",
                  y: "4.5",
                },
                _owner: null,
              },
            },
            _owner: null,
          },
          indeterminateIcon: {
            type: "svg",
            key: null,
            ref: null,
            props: {
              fill: "none",
              height: "24",
              viewBox: "0 0 24 24",
              width: "24",
              xmlns: "http://www.w3.org/2000/svg",
              children: {
                type: "path",
                key: null,
                ref: null,
                props: {
                  clipRule: "evenodd",
                  d: "M9 5.5H15C17.2091 5.5 19 7.29086 19 9.5V15.5C19 17.7091 17.2091 19.5 15 19.5H9C6.79086 19.5 5 17.7091 5 15.5V9.5C5 7.29086 6.79086 5.5 9 5.5ZM3 9.5C3 6.18629 5.68629 3.5 9 3.5H15C18.3137 3.5 21 6.18629 21 9.5V15.5C21 18.8137 18.3137 21.5 15 21.5H9C5.68629 21.5 3 18.8137 3 15.5V9.5ZM8 11.5C7.44772 11.5 7 11.9477 7 12.5C7 13.0523 7.44772 13.5 8 13.5H16C16.5523 13.5 17 13.0523 17 12.5C17 11.9477 16.5523 11.5 16 11.5H8Z",
                  fill: "currentColor",
                  fillRule: "evenodd",
                },
                _owner: null,
              },
            },
            _owner: null,
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            fontWeight: 500,
            borderColor: "#2F3746",
          },
          /* "icon": {
            "color": "#6C737F"
          } */
        },
      },
      MuiCssBaseline: {
        styleOverrides: {
          "*": {
            boxSizing: "border-box",
          },
          html: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            display: "flex",
            flexDirection: "column",
            minHeight: "100%",
            width: "100%",
          },
          body: {
            display: "flex",
            flex: "1 1 auto",
            flexDirection: "column",
            minHeight: "100%",
            width: "100%",
          },
          "#root, #__next": {
            display: "flex",
            flex: "1 1 auto",
            flexDirection: "column",
            height: "100%",
            width: "100%",
          },
          "#nprogress": {
            pointerEvents: "none",
          },
          "#nprogress .bar": {
            height: 3,
            left: 0,
            position: "fixed",
            top: 0,
            width: "100%",
            zIndex: 2000,
            backgroundColor: "#6366F1",
          },
          ".slick-dots li button": {
            "&:before": {
              fontSize: 10,
              color: "#6366F1",
            },
          },
          ".slick-dots li.slick-active button": {
            "&:before": {
              color: "#6366F1",
            },
          },
        },
      },
      MuiIconButton: {
        styleOverrides: {
          sizeSmall: {
            padding: 4,
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          input: {
            "&::placeholder": {
              opacity: 1,
              color: "#A0AEC0",
            },
          },
        },
      },
      MuiInput: {
        styleOverrides: {
          input: {
            fontSize: 14,
            fontWeight: 500,
            lineHeight: "24px",
          },
        },
      },
      MuiFilledInput: {
        styleOverrides: {
          root: {
            backgroundColor: "transparent",
            borderRadius: 8,
            borderStyle: "solid",
            borderWidth: 1,
            overflow: "hidden",
            transition:
              "border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
            "&:before": {
              display: "none",
            },
            "&:after": {
              display: "none",
            },
            borderColor: "#2D3748",
            "&:hover": {
              backgroundColor: "rgba(243, 244, 246, 0.04)",
            },
            "&.Mui-disabled": {
              backgroundColor: "transparent",
            },
            "&.Mui-focused": {
              backgroundColor: "transparent",
              borderColor: "#6366F1",
              boxShadow: "#6366F1 0 0 0 2px",
            },
            "&.Mui-error": {
              borderColor: "#F04438",
              boxShadow: "#F04438 0 0 0 2px",
            },
          },
          input: {
            fontSize: 14,
            fontWeight: 500,
            lineHeight: "24px",
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          input: {
            fontSize: 14,
            fontWeight: 500,
            lineHeight: "24px",
          },
          notchedOutline: {
            transition:
              "border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
            borderColor: "#2D3748",
          },
          root: {
            "&:hover": {
              backgroundColor: "rgba(243, 244, 246, 0.04)",
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#2D3748",
              },
            },
            "&.Mui-focused": {
              backgroundColor: "transparent",
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#6366F1",
                borderWidth: "3px",
              },
            },
            "&.Mui-error": {
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#F04438",
                borderWidth: "3px",
              },
            },
          },
        },
      },
      MuiFormLabel: {
        styleOverrides: {
          root: {
            fontSize: 14,
            fontWeight: 500,
            "&.MuiInputLabel-filled": {
              transform: "translate(12px, 18px) scale(1)",
            },
            "&.MuiInputLabel-shrink": {
              "&.MuiInputLabel-standard": {
                transform: "translate(0, -1.5px) scale(0.85)",
              },
              "&.MuiInputLabel-filled": {
                transform: "translate(12px, 6px) scale(0.85)",
              },
              "&.MuiInputLabel-outlined": {
                transform: "translate(14px, -9px) scale(0.85)",
              },
            },
          },
        },
      },
      MuiLinearProgress: {
        styleOverrides: {
          root: {
            borderRadius: 3,
            overflow: "hidden",
          },
        },
      },
      MuiLink: {
        defaultProps: {
          underline: "hover",
        },
      },
      MuiListItemIcon: {
        styleOverrides: {
          root: {
            marginRight: "16px",
            minWidth: "unset",
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: "none",
            borderRadius: 24,
          },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: {
            borderRadius: 28,
          },
        },
      },
      MuiPopover: {
        defaultProps: {
          elevation: 16,
        },
      },
      MuiRadio: {
        defaultProps: {
          color: "primary",
        },
      },
      MuiSwitch: {
        defaultProps: {
          color: "primary",
        },
        styleOverrides: {
          switchBase: {
            color: "#6C737F",
          },
          track: {
            backgroundColor: "#9DA4AE",
            opacity: 1,
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            fontSize: 14,
            fontWeight: 500,
            lineHeight: 1.71,
            minWidth: "auto",
            paddingLeft: 0,
            paddingRight: 0,
            textTransform: "none",
            "& + &": {
              marginLeft: 24,
            },
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            padding: "15px 16px",
            borderBottomColor: "#2D3748",
          },
        },
      },
      MuiTableHead: {
        styleOverrides: {
          root: {
            borderBottom: "none",
            "& .MuiTableCell-root": {
              borderBottom: "none",
              fontSize: 12,
              fontWeight: 600,
              lineHeight: 1,
              letterSpacing: 0.5,
              textTransform: "uppercase",
              backgroundColor: "#1C2536",
              color: "#9DA4AE",
            },
            "& .MuiTableCell-paddingCheckbox": {
              paddingTop: 4,
              paddingBottom: 4,
            },
          },
        },
      },
      MuiTextField: {
        defaultProps: {
          variant: "filled",
        },
      },
      MuiBackdrop: {
        styleOverrides: {
          root: {
            "&:not(.MuiBackdrop-invisible)": {
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              backdropFilter: "blur(6px)",
            },
          },
        },
      },
      MuiTimelineConnector: {
        styleOverrides: {
          root: {
            backgroundColor: "#2D3748",
          },
        },
      },
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            backdropFilter: "blur(6px)",
            background: "rgba(17, 25, 39, 0.8)",
          },
        },
      },
    },
    palette: {
      mode: "dark",
      common: {
        black: "#000",
        white: "#fff",
      },
      primary: {
        main: plataformIsBc ? "#FF2A85" : "#6366F1",
        light: plataformIsBc ? "#FF63A5" : "#818CF8",
        dark: plataformIsBc ? "#E6005C" : "#4F46E5",
        contrastText: "#FFFFFF",
        lightest: plataformIsBc ? "#FFE6F0" : "#EEF2FF",
        darkest: plataformIsBc ? "#800033" : "#312E81",
        alpha4: plataformIsBc ? "rgba(255, 42, 133, 0.04)" : "rgba(99, 102, 241, 0.04)",
        alpha8: plataformIsBc ? "rgba(255, 42, 133, 0.08)" : "rgba(99, 102, 241, 0.08)",
        alpha12: plataformIsBc ? "rgba(255, 42, 133, 0.12)" : "rgba(99, 102, 241, 0.12)",
        alpha30: plataformIsBc ? "rgba(255, 42, 133, 0.3)" : "rgba(99, 102, 241, 0.3)",
        alpha50: plataformIsBc ? "rgba(255, 42, 133, 0.5)" : "rgba(99, 102, 241, 0.5)",
      },
      secondary: {
        main: "#A78BFA",
        light: "#C4B5FD",
        dark: "#7C3AED",
        contrastText: "#fff",
      },
      error: {
        main: "#F87171",
        light: "#FCA5A5",
        dark: "#EF4444",
        contrastText: "#FFFFFF",
        lightest: "#FEF2F2",
        darkest: "#7F1D1D",
        alpha4: "rgba(248, 113, 113, 0.04)",
        alpha8: "rgba(248, 113, 113, 0.08)",
        alpha12: "rgba(248, 113, 113, 0.12)",
        alpha30: "rgba(248, 113, 113, 0.3)",
        alpha50: "rgba(248, 113, 113, 0.5)",
      },
      warning: {
        main: "#FBBF24",
        light: "#FCD34D",
        dark: "#F59E0B",
        contrastText: "#111827",
        lightest: "#FFFBEB",
        darkest: "#78350F",
        alpha4: "rgba(251, 191, 36, 0.04)",
        alpha8: "rgba(251, 191, 36, 0.08)",
        alpha12: "rgba(251, 191, 36, 0.12)",
        alpha30: "rgba(251, 191, 36, 0.3)",
        alpha50: "rgba(251, 191, 36, 0.5)",
      },
      info: {
        main: "#60A5FA",
        light: "#93C5FD",
        dark: "#3B82F6",
        contrastText: "#111827",
        lightest: "#EFF6FF",
        darkest: "#1E3A8A",
        alpha4: "rgba(96, 165, 250, 0.04)",
        alpha8: "rgba(96, 165, 250, 0.08)",
        alpha12: "rgba(96, 165, 250, 0.12)",
        alpha30: "rgba(96, 165, 250, 0.3)",
        alpha50: "rgba(96, 165, 250, 0.5)",
      },
      success: {
        main: "#34D399",
        light: "#6EE7B7",
        dark: "#10B981",
        contrastText: "#111827",
        lightest: "#ECFDF5",
        darkest: "#064E3B",
        alpha4: "rgba(52, 211, 153, 0.04)",
        alpha8: "rgba(52, 211, 153, 0.08)",
        alpha12: "rgba(52, 211, 153, 0.12)",
        alpha30: "rgba(52, 211, 153, 0.3)",
        alpha50: "rgba(52, 211, 153, 0.5)",
      },
      grey: {
        50: "#F9FAFB",
        100: "#F3F4F6",
        200: "#E5E7EB",
        300: "#D1D5DB",
        400: "#9CA3AF",
        500: "#6B7280",
        600: "#4B5563",
        700: "#374151",
        800: "#1F2937",
        900: "#111827",
      },
      contrastThreshold: 3,
      tonalOffset: 0.2,
      text: {
        primary: "#F9FAFB",
        secondary: "#9CA3AF",
        disabled: "rgba(249, 250, 251, 0.38)",
      },
      divider: "#1F2937",
      background: {
        paper: "#111827",
        appBar: "#0A0A0A",
        default: "#0A0A0A",
        pattern: {
          image: "none",
          repeat: "repeat",
          size: "400px",
          blend: "soft-light",
          attachment: "fixed"
        }
      },
      action: {
        active: "#9CA3AF",
        hover: "rgba(249, 250, 251, 0.04)",
        hoverOpacity: 0.04,
        selected: "rgba(249, 250, 251, 0.08)",
        selectedOpacity: 0.08,
        disabled: "rgba(249, 250, 251, 0.38)",
        disabledBackground: "rgba(249, 250, 251, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(249, 250, 251, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12,
      },
      neutral: {
        50: "#F9FAFB",
        100: "#F3F4F6",
        200: "#E5E7EB",
        300: "#D1D5DB",
        400: "#9CA3AF",
        500: "#6B7280",
        600: "#4B5563",
        700: "#374151",
        800: "#1F2937",
        900: "#111827",
      },
    },
    shadows: darkShadows,
  },
};

export const createCustomTheme = (config = {}) => {
  let themeOptions = themesOptions[config.theme];

  if (!themeOptions) {
    console.warn(new Error(`The theme ${config.theme} is not valid`));
    themeOptions = themesOptions[THEMES.LIGHT];
  }

  let theme = createTheme(
    merge(
      {},
      baseOptions,
      themeOptions,
      {
        ...(config.roundedCorners && {
          shape: {
            borderRadius: 16,
          },
        }),
      },
      {
        direction: config.direction,
      }
    ),
    ptBR
  ); // cria o tema com locale pt-br

  if (config.responsiveFontSizes) {
    theme = responsiveFontSizes(theme);
  }

  return theme;
};
